import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Não há nada para ver aqui...',
  subheader: 'Página não encontrada.',
  buttonText: 'Voltar à página inicial',
}
